import previewGroupNewTpl from '../templates/preview_groups/new.html';
import showTpl from '../templates/creative_preview/shared.html';
import editTpl from '../templates/preview_groups/edit.html';

export default function previewGroupRoutes($stateProvider) {
  $stateProvider.state('creativePreview.newPreviewGroup', {
    url: 'groups/new',
    template: previewGroupNewTpl,
    controller: 'PreviewGroupNewController',
    controllerAs: 'vm'
  });

  $stateProvider.state('creativePreview.showPreviewGroup', {
    url: 'groups/:id',
    template: showTpl,
    controller: 'PreviewGroupShowController',
    controllerAs: 'showVm',
    data: { isPreviewGroup: true, type: 'group' }
  });

  $stateProvider.state('creativePreview.editPreviewGroup', {
    url: 'groups/edit/:id',
    template: editTpl,
    controller: 'PreviewGroupEditController',
    controllerAs: 'editVm',
    data: { isPreviewGroup: true, type: 'group' }
  });
}

previewGroupRoutes.$inject = ['$stateProvider'];
